import { createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-80b15274")

_pushScopeId("data-v-80b15274")
const _hoisted_1 = { class: "card content-card" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Politika Privatnosti ")
const _hoisted_3 = {
  id: "app-types",
  class: "card"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode(" Ovaj dokument objašnjava kako proširenje e-Dnevnik Plus koristi i čuva vaše osobne podatke, prikupljene prilikom njena korištenja. Dokument se može promijeniti u bilo koje vrijeme o čemu ćete biti pravovremeno obaviješteni prilikom ažuriranja proširenja. <h3 data-v-80b15274>Koje osobne podatke proširenje prikuplja</h3> Prikupljeni osobni podaci su vaše korisničko ime i lozinka HUSO AAI računa. <h3 data-v-80b15274>Zašto proširenje prikuplja osobne podatke</h3> Podaci se koriste u svrhu automatske prijave ili odjave iz e-Dnevnika te za spremanje korisnikovih podataka poput bilješki i postavki u kalendaru. <h3 data-v-80b15274>Gdje se nalaze prikupljeni osobni podaci</h3> Svi prikupljeni podaci (ne samo osobni) ostaju spremljeni lokalno na vašem uređaju te podacima ne može pristupiti <strong data-v-80b15274>nitko osim vas</strong>. Prilikom deinstalacije svi podaci se trajno brišu. <h3 data-v-80b15274>Google Analytics</h3> U svrhu pružanja bolje usluge i razumijevanja potreba korisnika koristim se alatom Google Analytics. Iako Google bilježi veliki broj informacija poput geografskih i demografskih pokazatelja, vaši osobni podaci su zaštićeni te ne postoji način identifikacije korisnika. <h3 data-v-80b15274>Kontakt</h3> Upite vezane uz ovaj dokument možete tražiti putem email-a: <em data-v-80b15274>kristijan.ros@gmail.com</em>", 14)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Proširenje ne prikuplja podatke niti me izvještava o prometu na web mjestima e-Dnevnika.")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h2", null, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: { 'selected-app': !_ctx.selectedApp },
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedApp = 0))
        }, " za učenike i roditelje ", 2),
        _createVNode("div", {
          class: { 'selected-app': _ctx.selectedApp },
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedApp = 1))
        }, " za nastavnike ", 2)
      ])
    ]),
    (!_ctx.selectedApp)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _hoisted_4
        ], 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _hoisted_18
        ], 64))
  ]))
})